import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  _menuIsOpen = new BehaviorSubject(false);
  constructor() { }

  get menuIsOpen() {
    return this._menuIsOpen.asObservable();
  }

  nextMenuIsOpen(open: boolean) {
    this._menuIsOpen.next(open);
  }
}
